import { useEffect, useState } from 'react'
import { Modal, OverlayTrigger, Table, Tooltip } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/free-solid-svg-icons'

import Affiliate from '../../../../templates/Affiliate/Affiliate'
import Dollars from '../../../../templates/Dollars/Dollars'
import Loading from '../../../../templates/UI/Loading/Loading'
import callAPI from '../../../../helpers/callAPI'

const AffiliatesWithLeadsModal = ({ show, onHide, managerId, requestPath }) => {
    const [dataLoaded, setDataLoaded] = useState(false)
    const [affiliatesWithLeads, setAffiliatesWithLeads] = useState([])

    useEffect(() => {
        const fetchAffiliatesWithLeads = async () => {
            if (!show || !managerId) {
                return
            }

            setDataLoaded(false)

            const path = requestPath || `summary/juniorAffiliateManager/${managerId}/affswithleads`
            const response = await callAPI(path, 'GET', null)

            if (response.success || response.status === 'success') {
                setAffiliatesWithLeads(response.list_of_affiliates_with_leads || [])
            } else {
                console.log(response.success)
                setAffiliatesWithLeads([])
            }

            setDataLoaded(true)
        }

        fetchAffiliatesWithLeads()
    }, [show, managerId, requestPath])

    return (
        <Modal show={show} onHide={onHide} size="lg">
                {dataLoaded ? (
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Affiliate ID</th>
                                <th>Affiliates With Leads</th>
                                <th className="text-right">Affiliate Earnings (30d)</th>
                                <th className="text-right">Network Earnings (30d)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {affiliatesWithLeads.length > 0 ? (
                                affiliatesWithLeads.map((affiliate) => (
                                    <tr key={affiliate.id}>
                                        <td>{affiliate.id}</td>
                                        <td>
                                            <Affiliate aid={affiliate.id} name={affiliate.name} priority={affiliate.aff_priority} status={affiliate.status} />
                                            {affiliate.last_24hrs === 'Y' && (
                                                <OverlayTrigger placement="top" overlay={<Tooltip id="default-rate-tooltip">New</Tooltip>}>
                                                    <FontAwesomeIcon icon={faStar} className="mr-1" style={{ color: 'green', fontSize: '10px' }} />
                                                </OverlayTrigger>
                                            )}
                                        </td>
                                        <td className="text-right">
                                            <Dollars value={affiliate.affiliate_earnings} />
                                        </td>
                                        <td className="text-right">
                                            <Dollars value={affiliate.network_earnings} />
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={4}>No affiliates with leads found.</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                ) : (
                    <Loading />
                )}
        </Modal>
    )
}

export default AffiliatesWithLeadsModal
